import { gql } from "graphql-request";

export const registration = {
  getRegistration: gql`
    query registration($token: String!) {
      registration(token: $token) {
        email
        projectName
        originatorOrgName
        inviteeOrgDetails {
          name
          shortName
          country
          countryName
        }
      }
    }
  `,
};
